// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateCarrierConfigAggregatorDto
 */
export interface ICreateCarrierConfigAggregatorDto {
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    carrier_external_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    submitter_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    service_date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    service_date_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    purpose_type?: ICreateCarrierConfigAggregatorDtoPurposeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    claim_autopay_type?: ICreateCarrierConfigAggregatorDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    is_dependent_deidentified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    is_dependent_autocreated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    status_type?: ICreateCarrierConfigAggregatorDtoStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    claim_payee_type?: ICreateCarrierConfigAggregatorDtoClaimPayeeTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ICreateCarrierConfigAggregatorDto
     */
    amount_types?: Array<ICreateCarrierConfigAggregatorDtoAmountTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum ICreateCarrierConfigAggregatorDtoPurposeTypeEnum {
    CLAIM_CREATION = 'CLAIM_CREATION',
    ADJUDICATION = 'ADJUDICATION'
}
/**
* @export
* @enum {string}
*/
export enum ICreateCarrierConfigAggregatorDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ICreateCarrierConfigAggregatorDtoStatusTypeEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum ICreateCarrierConfigAggregatorDtoClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum ICreateCarrierConfigAggregatorDtoAmountTypesEnum {
    COINSURANCE = 'COINSURANCE',
    COPAY = 'COPAY',
    PATIENT_RESPONSIBILITY = 'PATIENT_RESPONSIBILITY',
    DEDUCTIBLE = 'DEDUCTIBLE',
    MIXED = 'MIXED'
}


/**
 * Check if a given object implements the ICreateCarrierConfigAggregatorDto interface.
 */
export function instanceOfICreateCarrierConfigAggregatorDto(value: object): value is ICreateCarrierConfigAggregatorDto {
    return true;
}

export function ICreateCarrierConfigAggregatorDtoFromJSON(json: any): ICreateCarrierConfigAggregatorDto {
    return ICreateCarrierConfigAggregatorDtoFromJSONTyped(json, false);
}

export function ICreateCarrierConfigAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateCarrierConfigAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'carrier_external_id': json['carrier_external_id'] == null ? undefined : json['carrier_external_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'submitter_id': json['submitter_id'] == null ? undefined : json['submitter_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'service_date_from': json['service_date_from'] == null ? undefined : (new Date(json['service_date_from'])),
        'service_date_to': json['service_date_to'] == null ? undefined : (new Date(json['service_date_to'])),
        'purpose_type': json['purpose_type'] == null ? undefined : json['purpose_type'],
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'is_dependent_deidentified': json['is_dependent_deidentified'] == null ? undefined : json['is_dependent_deidentified'],
        'is_dependent_autocreated': json['is_dependent_autocreated'] == null ? undefined : json['is_dependent_autocreated'],
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'claim_payee_type': json['claim_payee_type'] == null ? undefined : json['claim_payee_type'],
        'amount_types': json['amount_types'] == null ? undefined : json['amount_types'],
    };
}

export function ICreateCarrierConfigAggregatorDtoToJSON(json: any): ICreateCarrierConfigAggregatorDto {
    return ICreateCarrierConfigAggregatorDtoToJSONTyped(json, false);
}

export function ICreateCarrierConfigAggregatorDtoToJSONTyped(value?: ICreateCarrierConfigAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_external_id': value['carrier_external_id'],
        'organization_id': value['organization_id'],
        'submitter_id': value['submitter_id'],
        'description': value['description'],
        'service_date_from': value['service_date_from'] == null ? undefined : ((value['service_date_from']).toISOString()),
        'service_date_to': value['service_date_to'] == null ? undefined : ((value['service_date_to']).toISOString()),
        'purpose_type': value['purpose_type'],
        'claim_autopay_type': value['claim_autopay_type'],
        'is_dependent_deidentified': value['is_dependent_deidentified'],
        'is_dependent_autocreated': value['is_dependent_autocreated'],
        'status_type': value['status_type'],
        'claim_payee_type': value['claim_payee_type'],
        'amount_types': value['amount_types'],
    };
}

